import React, { useEffect, useState } from 'react'; // PLENARIUM:APP_CONTINUA_LOGADO
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import EntradaVereador from '../components/EntradaVereador'; // PLENARIUM:ENTRADA_VEREADOR

export default function LoginVereador() {
  const { loginVereador, usuario } = useAuth(); // PLENARIUM:APP_CONTINUA_LOGADO
  const navigate = useNavigate();
  // PLENARIUM:APP_CONTINUA_LOGADO -- o app do tablet abre nesta tela. Se o vereador ja esta logado,
  // vai direto para o painel (antes mostrava o login de novo e parecia que tinha saido)
  useEffect(() => { if (usuario && usuario.role === 'vereador') navigate('/vereador', { replace: true }); }, [usuario, navigate]);
  const [erro, setErro] = useState('');

  const entrar = async (cpf, senha) => {
    try {
      await loginVereador(cpf, senha);
      navigate('/vereador');
    } catch (err) {
      setErro(err.response?.data?.error || 'CPF ou senha inválidos');
    }
  };

  return <EntradaVereador onEntrar={entrar} erro={erro} setErro={setErro} />;
}
